export default __webpack_public_path__ + "static/media/203.9d9b775d.png";